import useAppFunctionalityConfig from "hooks/useAppFunctionalityConfig";
import { SnackbarProvider, MaterialDesignContent } from "notistack";

// MUI
import { Box } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircleRounded";
import InfoIcon from "@mui/icons-material/InfoRounded";
import ErrorIcon from "@mui/icons-material/ErrorRounded";
import WarningIcon from '@mui/icons-material/WarningRounded';
import { styled } from '@mui/material/styles';

// project import
import Routes from "routes";
import { EditEntityDialogProvider } from "components/dialogs/EditEntityDialogProvider";
import ThemeCustomization from "themes";
import Locales from "components/Locales";
// import RTLLayout from 'components/RTLLayout'; 
import ScrollTop from "components/ScrollTop";

// auth provider
import { FirebaseProvider as AuthProvider } from "contexts/FirebaseContext";

// app settings provider
import { AppSettingsProvider } from "contexts/AppSettingsContext";

// files provider
import { FilesProvider } from "contexts/FilesContext";

// Estates an maps data provider
import { EstatesAndMapsProvider } from "contexts/EstatesAndMapsContext";

// Map data provider
import { MapDataProvider } from "contexts/MapDataContext";

// Onboarding
import Onboarding from "features/onboarding";
import EnvironmentMonitor from "features/environmentMonitor";
import TestBrandSwitcher from "components/branding/TestBrandSwitcher"; 
import AudienceTemplateLoader from "features/publicMapInformation/audienceTemplateLoader";

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent-success': {
    backgroundColor: '#E6F4EC',
    color: '#2A614A',
    borderLeft: '4px solid #488B55'
  },

  '&.notistack-MuiContent-error': {
    backgroundColor: '#FDEBEC',
    color: '#B93831',
    borderLeft: '4px solid #D6453D'
  },

  '&.notistack-MuiContent-warning': {
    backgroundColor: '#FFF6E5',
    color: '#9C7625',
    borderLeft: '4px solid #B88E2E'
  },

  '&.notistack-MuiContent-info': {
    backgroundColor: '#E6F2F4',
    color: '#245F67',
    borderLeft: '4px solid #2F7F8A'
  },

  borderRadius: 10,
  padding: '10px 16px',
  fontWeight: 500,
  '& .MuiSvgIcon-root': {
    color: 'inherit'
  }
}));

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //
const App = () => {
  const { isAudienceMode } = useAppFunctionalityConfig();
  return (
    <ThemeCustomization>
      {/* <RTLLayout> */}
      <SnackbarProvider
        maxSnack={3}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        preventDuplicate
        Components={{
          success: StyledMaterialDesignContent,
          error: StyledMaterialDesignContent,
          warning: StyledMaterialDesignContent,
          info: StyledMaterialDesignContent
        }}
        iconVariant={{
          success: <Box sx={{ mr: 1, mt: 0.7 }}><CheckCircleIcon /></Box>,
          error: <Box sx={{ mr: 1, mt: 0.7 }}><ErrorIcon /></Box>,
          warning: <Box sx={{ mr: 1, mt: 0.7 }}><WarningIcon /></Box>,
          info: <Box sx={{ mr: 1, mt: 0.7 }}><InfoIcon /></Box>,
        }}
      >
        <Locales>
          <ScrollTop>
            <AppSettingsProvider>
              <AuthProvider>
                <AudienceTemplateLoader />
                <EstatesAndMapsProvider>
                  <MapDataProvider>
                    <FilesProvider>
                      <>
                        {/* <Notifier /> */}
                        <EnvironmentMonitor />
                        {!isAudienceMode && <Onboarding />}
                        <EditEntityDialogProvider>
                          <Routes />
                        </EditEntityDialogProvider>
                        <TestBrandSwitcher />
                        {/* <Snackbar /> */}
                      </>
                    </FilesProvider>
                  </MapDataProvider>
                </EstatesAndMapsProvider>
              </AuthProvider>
            </AppSettingsProvider>
          </ScrollTop>
        </Locales>
      </SnackbarProvider>
      {/* </RTLLayout> */}
    </ThemeCustomization>
  );
};

export default App;
